<template lang="html">
  <use :xlink:href="path"></use>
</template>

<script>

  export default {
    name: 'sprite',

    props: {
      name: String
    },

    computed: {
      path() {
        return `#${this.name}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/UseSvg.vue